import { Component } from '@angular/core';
import { ApiInterfacesTableComponent } from './api-interfaces-table/api-interfaces-table.component';
import { MdbButtonComponent } from '../../utils/mdb-button/mdb-button.component';
import { NewApiInterfaceModalComponent } from './new-api-interface-modal/new-api-interface-modal.component';
import { CustomNotificationService } from '../../../services/utils/custom-notification.service';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { ApiInterfaceService } from '../../../services/resources/api-interface.service';

@Component({
  selector: 'app-api-interfaces',
  imports: [
    ApiInterfacesTableComponent,
    MdbButtonComponent
  ],
  templateUrl: './api-interfaces.component.html',
  styleUrl: './api-interfaces.component.scss'
})
export class ApiInterfacesComponent {
  constructor(
    private notificationService: CustomNotificationService,
    private modalService: MdbModalService,
    private apiInterfaceService: ApiInterfaceService
  ) {}
  openNewApiInterfaceModal() {
    let modalRef = this.modalService.open(NewApiInterfaceModalComponent, {
      modalClass: 'modal-xl',
      ignoreBackdropClick: true,
    });
    modalRef.onClose.subscribe((apiInterface) => {
      if (!apiInterface)
        return;

      this.notificationService.success('API_INTERFACES.SUCCESSFULLY_CREATED');
    });
  }
}
